<template>
<div>
    Account pages
</div>
</template>

<script>
  export default {
    name: 'NewAccount',
    data: () => ({
    })
  }
</script>